<script lang="ts">import { Text } from "@infinitro/text";
export let title;
</script>

<Text type="title" titleSize="h4" titleWeight="bold" textAlign="center">{title}</Text>
